import {useEffect, useRef } from 'react';
import { User } from 'lucide-react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonialCardsRef = useRef([]);

  const testimonials = [
    {
      id: 1,
      name: "Rajesh Kumar",
      role: "Homeowner",
      review: "The quality of Aultra Paints is exceptional. Our home looks vibrant and fresh even after two years. The colors haven't faded at all and the finish is still smooth.",
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "Interior Designer",
      review: "I've been recommending Aultra Paints to all my clients. Their color range is impressive and the application is smooth. The customer service team is also very responsive and helpful.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop"
    },
    {
      id: 3,
      name: "Amit Patel",
      role: "Contractor",
      review: "Working with Aultra products makes my job easier. The paint covers well, dries quickly, and my clients are always satisfied with the results. Great value for money.",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop"
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      testimonialCardsRef.current.forEach((card, index) => {
        if (card) {
          const rect = card.getBoundingClientRect();
          const isInView = rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
          
          if (isInView) {
            setTimeout(() => {
              card.classList.add('testimonials__animate-in');
            }, index * 100);
          } else {
            card.classList.remove('testimonials__animate-in');
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="testimonials">
      <div className="testimonials__container">
        <div className="testimonials__header">
          <h2 className="testimonials__title">What Our Customers Say</h2>
          <p className="testimonials__subtitle">
            Trusted by thousands of satisfied customers
          </p>
        </div>

        <div className="testimonials__grid">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`testimonials__card ${index % 2 === 0 ? 'testimonials__card--even' : 'testimonials__card--odd'}`}
              ref={(el) => (testimonialCardsRef.current[index] = el)}
            >
              <div className="testimonials__quote-icon">"</div>
              <p className="testimonials__review">"{testimonial.review}"</p>
              <div className="testimonials__author">
                <User size="2rem"/>
                <div className="testimonials__author-info">
                  <h4 className="testimonials__name">{testimonial.name}</h4>
                  <p className="testimonials__role">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
